/*! esyon-wishlist v2 — packed in esyon-theme ERP feature.
 *  Storage: ERP App Proxy + Shopify customer metafield (logged-in) + localStorage (anonymous).
 *  Auto-merges localStorage into the customer metafield on login. */
(function () {
  'use strict';
  if (window.EsyonWishlist) return;

  // ---------- bootstrap ----------
  const boot = (() => {
    try {
      const el = document.querySelector('script[data-esyon-bootstrap]');
      return el ? JSON.parse(el.textContent || '{}') : {};
    } catch (e) { return {}; }
  })();

  const WISHLIST_URL = boot.wishlistUrl || '/pages/wishlist';
  const ACCOUNT_URL = boot.accountUrl || '/account';
  const IS_LOGGED_IN = !!boot.isLoggedIn;
  const LS_KEY = 'esyon.wishlist.local.v1';
  // Shopify App Proxy 同域路径; Shopify 转发到 ERP, 自动带 logged_in_customer_id + HMAC.
  const PROXY_PATH = '/apps/esyon/wishlist';

  // 登录态先乐观假设远端可用; readRemote/writeRemote 拿到 401 后会 set false 并降级到 localStorage.
  let remoteAvail = IS_LOGGED_IN;

  // ---------- SVG (Lucide) ----------
  const SVG = {
    heart:       '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M2 9.5a5.5 5.5 0 0 1 9.591-3.676.56.56 0 0 0 .818 0A5.49 5.49 0 0 1 22 9.5c0 2.29-1.5 4-3 5.5l-5.492 5.313a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5"/></svg>',
    heartPlus:   '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m14.479 19.374-.971.939a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5a5.5 5.5 0 0 1 9.591-3.676.56.56 0 0 0 .818 0A5.49 5.49 0 0 1 22 9.5a5.2 5.2 0 0 1-.219 1.49"/><path d="M15 15h6"/><path d="M18 12v6"/></svg>',
    heartFilled: '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M2 9.5a5.5 5.5 0 0 1 9.591-3.676.56.56 0 0 0 .818 0A5.49 5.49 0 0 1 22 9.5c0 2.29-1.5 4-3 5.5l-5.492 5.313a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5"/></svg>',
  };

  // ---------- inline styles (single injection) ----------
  const STYLES = '' +
    '.esyon-wish-btn{display:inline-flex;align-items:center;justify-content:center;' +
      'background:transparent;border:none;border-radius:999px;width:36px;height:36px;' +
      'cursor:pointer;color:currentColor;' +
      'transition:color .15s ease,transform .15s ease;padding:0}' +
    '.esyon-wish-btn:hover{transform:scale(1.08)}' +
    '.esyon-wish-btn[aria-pressed="true"]{color:#000}' +
    '.esyon-wish-btn[disabled]{opacity:.55;cursor:wait}' +
    '.esyon-wish-btn svg{display:block;pointer-events:none}' +
    'product-card{position:relative}' +
    'esyon-wishlist-heart{position:absolute;top:8px;right:8px;z-index:3;display:inline-flex}' +
    'esyon-wishlist-heart[data-variant="inline"]{position:static;top:auto;right:auto}' +
    '.esyon-wish-nav{display:inline-flex;align-items:center;justify-content:center;color:inherit;text-decoration:none}' +
    '.esyon-toast{position:fixed;bottom:24px;left:50%;' +
      'transform:translateX(-50%) translateY(10px);background:rgba(20,20,20,.92);color:#fff;' +
      'padding:10px 18px;border-radius:999px;font-size:14px;opacity:0;pointer-events:none;' +
      'z-index:10000;transition:opacity .2s ease,transform .2s ease;max-width:80vw;text-align:center}' +
    '.esyon-toast.is-visible{opacity:1;transform:translateX(-50%) translateY(0)}' +
    '.esyon-wishlist-fallback-card{display:flex;flex-direction:column;background:#fff;' +
      'border:1px solid #eee;border-radius:8px;overflow:hidden;text-decoration:none;color:inherit}' +
    '.esyon-wishlist-fallback-card img{width:100%;aspect-ratio:1/1;object-fit:cover;display:block;background:#f5f5f5}' +
    '.esyon-wishlist-fallback-card .ewf-body{padding:10px 12px;font-size:14px}' +
    '.esyon-wishlist-fallback-card .ewf-title{display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;line-height:1.3;min-height:2.6em}' +
    '.esyon-wishlist-fallback-card .ewf-price{margin-top:6px;font-weight:600}';

  function injectStyles() {
    if (document.getElementById('esyon-wishlist-styles')) return;
    const s = document.createElement('style');
    s.id = 'esyon-wishlist-styles';
    s.textContent = STYLES;
    document.head.appendChild(s);
  }

  // ---------- localStorage ----------
  function readLocal() {
    try {
      const raw = localStorage.getItem(LS_KEY);
      const list = JSON.parse(raw || '[]');
      return Array.isArray(list) ? list.filter(x => typeof x === 'string') : [];
    } catch (e) { return []; }
  }
  function writeLocal(list) {
    try { localStorage.setItem(LS_KEY, JSON.stringify(list)); } catch (e) {}
  }
  function clearLocal() {
    try { localStorage.removeItem(LS_KEY); } catch (e) {}
  }

  // ---------- ERP App Proxy transport ----------
  let remoteCache = null; // { list, ts }
  const CACHE_TTL = 5 * 60 * 1000;

  async function readRemote() {
    if (!remoteAvail) return readLocal();
    if (remoteCache && Date.now() - remoteCache.ts < CACHE_TTL) return remoteCache.list;
    try {
      const r = await fetch(PROXY_PATH, { credentials: 'same-origin' });
      if (r.status === 401 || r.status === 404) {
        remoteAvail = false;
        console.warn('[esyon-wishlist] App Proxy unavailable (status ' + r.status + '). Falling back to localStorage only.');
        return readLocal();
      }
      if (!r.ok) throw new Error('readRemote http ' + r.status);
      const j = await r.json();
      if (!j.ok) throw new Error('readRemote not ok: ' + (j.error || ''));
      const list = Array.isArray(j.list) ? j.list.filter(function (x) { return typeof x === 'string'; }) : [];
      remoteCache = { list: list, ts: Date.now() };
      return list;
    } catch (e) {
      console.warn('[esyon-wishlist] readRemote failed:', e.message);
      return readLocal();
    }
  }

  async function writeRemote(list) {
    if (!remoteAvail) { writeLocal(list); return; }
    const r = await fetch(PROXY_PATH, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ list: list }),
    });
    if (r.status === 401 || r.status === 404) {
      remoteAvail = false;
      throw new Error('writeRemote unauth: ' + r.status);
    }
    if (!r.ok) throw new Error('writeRemote http ' + r.status);
    const j = await r.json();
    if (!j.ok) throw new Error('writeRemote not ok: ' + (j.error || ''));
    remoteCache = { list: list, ts: Date.now() };
  }

  // ---------- migration ----------
  let migratePromise = null;
  function migrateIfNeeded() {
    if (!remoteAvail) return Promise.resolve();
    if (migratePromise) return migratePromise;
    const local = readLocal();
    if (!local.length) return Promise.resolve();
    migratePromise = (async () => {
      const remote = await readRemote();
      const merged = Array.from(new Set([].concat(remote, local)));
      if (merged.length !== remote.length) {
        await writeRemote(merged);  // throws on failure; localStorage preserved
      }
      clearLocal();  // only after write succeeded
      window.dispatchEvent(new CustomEvent('esyon:wishlist:change'));
    })().catch(function (e) {
      console.warn('[esyon-wishlist] migrate failed, keeping localStorage:', e.message);
    });
    return migratePromise;
  }

  // ---------- toast ----------
  let toastTimer = null;
  function toast(msg) {
    let el = document.querySelector('.esyon-toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'esyon-toast';
      document.body.appendChild(el);
    }
    el.textContent = msg;
    requestAnimationFrame(function () { el.classList.add('is-visible'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 2000);
  }

  // ---------- public API ----------
  const EsyonWishlist = {
    SVG: SVG,
    boot: boot,
    isRemote: function () { return remoteAvail; },
    async get() {
      await migrateIfNeeded();
      return remoteAvail ? readRemote() : readLocal();
    },
    async has(handle) {
      if (!handle) return false;
      const list = await this.get();
      return list.indexOf(handle) >= 0;
    },
    async count() {
      const list = await this.get();
      return list.length;
    },
    async toggle(handle) {
      if (!handle) return { added: false, list: [] };
      await migrateIfNeeded();
      const list = await this.get();
      const idx = list.indexOf(handle);
      const added = idx < 0;
      const next = added ? list.concat([handle]) : list.filter(function (h) { return h !== handle; });
      try {
        if (remoteAvail) await writeRemote(next); else writeLocal(next);
      } catch (e) {
        console.warn('[esyon-wishlist] toggle remote write failed, saving locally:', e.message);
        writeLocal(next);  // 保底, 数据不丢
        window.dispatchEvent(new CustomEvent('esyon:wishlist:change'));
        toast('Saved (sync failed)');
        return { added: added, list: next };
      }
      window.dispatchEvent(new CustomEvent('esyon:wishlist:change'));
      toast(added ? 'Added to wishlist' : 'Removed from wishlist');
      return { added: added, list: next };
    },
    // 给 wishlist-page 用的最简卡片 fallback (alt view 不可用时):从 /products/<h>.js 拿 JSON 自己渲染
    async buildFallbackCard(handle) {
      try {
        const r = await fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } });
        if (!r.ok) return null;
        const p = await r.json();
        const img = (p.featured_image || (p.images && p.images[0]) || '');
        const price = (p.price != null ? (p.price / 100).toLocaleString(undefined, { maximumFractionDigits: 0 }) + ' Ft' : '');
        const wrap = document.createElement('a');
        wrap.className = 'esyon-wishlist-fallback-card';
        wrap.href = '/products/' + encodeURIComponent(handle);
        wrap.innerHTML =
          (img ? '<img loading="lazy" src="' + img + '" alt="">' : '') +
          '<div class="ewf-body"><div class="ewf-title">' + (p.title || handle) + '</div>' +
          (price ? '<div class="ewf-price">' + price + '</div>' : '') +
          '</div>';
        return wrap;
      } catch (e) { return null; }
    },
  };
  window.EsyonWishlist = EsyonWishlist;

  // ---------- web components ----------
  class WishHeart extends HTMLElement {
    connectedCallback() {
      this.handle = this.dataset.handle || '';
      if (!this.handle) return;
      this._render(false);
      EsyonWishlist.has(this.handle).then((v) => this._render(v));
      this._onChange = () => EsyonWishlist.has(this.handle).then((v) => this._render(v));
      window.addEventListener('esyon:wishlist:change', this._onChange);
      this.addEventListener('click', this._onClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (this._busy) return;
        this._busy = true;
        const btn = this.querySelector('button');
        if (btn) btn.disabled = true;
        EsyonWishlist.toggle(this.handle).finally(() => {
          this._busy = false;
          const b = this.querySelector('button');
          if (b) b.disabled = false;
        });
      });
    }
    disconnectedCallback() {
      window.removeEventListener('esyon:wishlist:change', this._onChange);
    }
    _render(active) {
      const icon = active ? SVG.heartFilled : SVG.heartPlus;
      const label = active ? 'Remove from wishlist' : 'Add to wishlist';
      this.innerHTML = '<button type="button" class="esyon-wish-btn" aria-pressed="' +
        (active ? 'true' : 'false') + '" aria-label="' + label + '" title="' + label + '">' + icon + '</button>';
    }
  }
  if (!customElements.get('esyon-wishlist-heart')) {
    customElements.define('esyon-wishlist-heart', WishHeart);
  }

  // ---------- init ----------
  injectStyles();
  if (remoteAvail) migrateIfNeeded(); // background

  // bfcache: 浏览器 back/forward 复活整页时, DOM/JS 冻结状态被还原, 不会重新连 connectedCallback.
  // 派发 change 事件让所有 heart 重读 localStorage / metafield 并重画.
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) window.dispatchEvent(new CustomEvent('esyon:wishlist:change'));
  });
  // 跨标签页同步: 同域多 tab 时另一个 tab 改 localStorage, 当前 tab 能立刻刷新.
  window.addEventListener('storage', function (e) {
    if (e.key === 'esyon.wishlist.local.v1') {
      window.dispatchEvent(new CustomEvent('esyon:wishlist:change'));
    }
  });
})();
